import * as React from "react";
import { Edit, SimpleForm, AutocompleteInput, TextInput, PasswordInput, ArrayInput, SimpleFormIterator, ReferenceArrayInput, SelectArrayInput } from 'react-admin';

export const InternalUpdate = props => (
  <Edit title="Edit External" undoable={false} {...props}>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="label" required />
      <TextInput source="email" required />
      <TextInput source="phone_label_name" label="Phone label name" required />
      <ReferenceArrayInput source="externals" reference="externals">
        <SelectArrayInput optionText="label" optionValue="_id" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
);

// "request": {
//   "url": "http://localhost:8000/api/v1/sandbox/external_data",
//   "method": "POST",
//   "headers": { }
// }
